<div class="page-container jumbotron1">

    <div class="content-wrapper tw:flex tw:flex-col tw:p-0">

      <div class="tw:flex tw:flex-nowrap tw:gap-4 tw:p-0 tw:m-0 tw:grow tw:min-h-0">

        <div class="tw:flex-none c-sidenav">
          <nav-menu></nav-menu>
        </div>

        <div class="tw:flex-1 tw:flex tw:flex-col tw:min-h-0">
          @if (versionCheckService.updateAvailable()) {
            <div class="tw:flex tw:items-center tw:justify-between tw:gap-4 tw:mx-3 tw:mt-2 tw:px-4 tw:py-2 tw:rounded-xl tw:border tw:border-amber-300 tw:bg-amber-50" role="status">
              <span>A new version of Tuition Management is available. Save anything you are working on, then refresh to start using it.</span>
              <button type="button" class="btn btn-primary btn-sm tw:shrink-0" (click)="versionCheckService.reload()">Refresh</button>
            </div>
          }
          <div class="c-breadcrumb">
            <div class="breadcrumb-trail bct">
              <div class="bct__node bct__node--home cursor-pointer" [routerLink]="['/']">
                <i class="las la-home"></i>
              </div>
              <div class="bct__node cursor-pointer" [routerLink]="['/']">
                Tuition Management
              </div>
              @for (node of breadcrumbService.breadcrumb.parents; track $index) {
                <div class="bct__node cursor-pointer" [routerLink]="breadcrumbLink(node)">
                  {{node.name}}
                </div>
              }
              <div class="bct__node bct__node--active">{{breadcrumbService.breadcrumb.routeName}}</div>
            </div>
          </div>
          <div class="content-scroll tw:flex tw:flex-col">
            <utility-bar [utilityTemplate]="utilityTemplate"></utility-bar>
            <div class="tw:grow tw:shrink-0 tw:bg-white tw:border-b tw:shadow tw:py-2 tw:px-6 tw:mx-3 tw:rounded-xl">

              <router-outlet #outlet="outlet" (activate)="onRouterOutletActivate($event)">
              </router-outlet>

            </div>
          </div>
        </div>
      </div>

    </div>

  <app-toasts></app-toasts>
</div>
